var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-block-center-container"},[_c('h5',{staticClass:"title-content",class:_vm.device.isMobile ? 'title-content-mobile' : '',style:({
      fontFamily: _vm.content.textStyle.fontFamily || '',
      fontSize: (_vm.content.textStyle.fontSize + 'rem') || '',
      lineHeight: (_vm.content.textStyle.lineHeight + 'rem') || '',
      textIndent: (typeof _vm.content.textStyle.textIndent === 'string') ? _vm.content.textStyle.textIndent :
        (typeof _vm.content.textStyle.textIndent === 'number') ? (_vm.content.textStyle.textIndent + 'rem') : '',
      fontWeight: _vm.content.textStyle.fontWeight || '',
      textDecoration: _vm.content.textStyle.underline === 1 ? 'underline' : '',
      fontStyle: _vm.content.textStyle.fontItalic === 1 ? 'italic' : '',
      textAlign: _vm.content.textStyle.textAlign || '',
      color: _vm.content.textStyle.color || '',
      backgroundColor: _vm.content.textStyle.backgroundColor || '',
      backgroundImage: _vm.content.textStyle.backgroundImage ? ("url(" + (_vm.content.textStyle.backgroundImage) + ")") : '',
      width: (typeof _vm.content.textStyle.width === 'string') ? _vm.content.textStyle.width :
        (typeof _vm.content.textStyle.width === 'number') ? (_vm.content.textStyle.width + 'rem') : '',
      marginTop: (_vm.content.textStyle.marginTop + 'rem') || '',
      marginBottom: (_vm.content.textStyle.marginBottom + 'rem') || '',
      padding: (typeof _vm.content.textStyle.padding === 'number' && (_vm.content.textStyle.padding + 'rem')) || '',
      paddingTop: (typeof _vm.content.textStyle.paddingTop === 'number' && (_vm.content.textStyle.paddingTop + 'rem')) || '',
      paddingBottom: (typeof _vm.content.textStyle.paddingBottom === 'number' && (_vm.content.textStyle.paddingBottom + 'rem')) || '',
      paddingLeft: (typeof _vm.content.textStyle.paddingLeft === 'number' && (_vm.content.textStyle.paddingLeft + 'rem')) || '',
      paddingRight: (typeof _vm.content.textStyle.paddingRight === 'number' && (_vm.content.textStyle.paddingRight + 'rem')) || '',
      borderRadius: _vm.content.textStyle.borderRadius
        ? _vm.content.textStyle.borderRadius.borderTopLeftRadius +
          'rem' +
          ' ' +
          (_vm.content.textStyle.borderRadius.borderTopRightRadius + 'rem') +
          ' ' +
          (_vm.content.textStyle.borderRadius.borderBottomRightRadius + 'rem') +
          ' ' +
          (_vm.content.textStyle.borderRadius.borderBottomLeftRadius + 'rem')
        : '',
    }),attrs:{"id":_vm.content.key},domProps:{"innerHTML":_vm._s(_vm.content.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }